import { Injectable } from '@angular/core';
import { Account, Asset, BuyingPowerDetails, Customer, EnrolledDevice, InstrumentType } from '@zero/shared/util-models';
import { Session } from 'diffusion';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable()
export abstract class AbstractDiffusionSessionService {
  public abstract diffusionSession$: Observable<Session>;
}

@Injectable()
export abstract class AbstractAuthService {
  public abstract isCustomer$(): Observable<boolean>;
  public abstract isLoggedIn$(): Observable<boolean>;
  public abstract getAuthToken(): Observable<string>;
}

@Injectable()
export abstract class AbstractDataService {
  public abstract getSelectedCustomerItem?(): Customer;
  public abstract loadCustomerAccount$(forceReload: boolean): Subject<Account>;
  public abstract loadBPDetails$(isin?: string): Observable<BuyingPowerDetails>;
  public abstract getSelectedCustomer(): string;
  public abstract getEnrolledDevices$?(): Observable<EnrolledDevice[]>;
  public selectedCustomerChanged? = new ReplaySubject<string>(1);
}

@Injectable()
export abstract class AbstractTradingService {
  public abstract confirmLowTrading(): Promise<boolean>;
  public abstract initAssetDependingValues(asset: Asset): void;
  public abstract showDisproportionateFeesHint(orderValue: number): boolean;
  public abstract showLowTrading(): boolean;
  public abstract showLowTradingHint(instrumentType?: InstrumentType, orderValue?: number): boolean;

  public abstract lowTradingThreshold: number;
  public abstract lowTradingThresholdQuantity: number;
  public abstract minimumQuantitySurcharge: number;
}

@Injectable()
export abstract class AbstractUserMessagesHolderService {
  public abstract addErrorMessage(msg: string, addTime?: boolean): unknown;
  public abstract clearAllMessages(): unknown;
}

@Injectable()
export abstract class AbstractMetaDataService {
  public abstract setTitle(title: string): void;
  public abstract addErrorMessage(msg: string, addTime?: boolean): unknown;
  public abstract clearAllMessages(): unknown;
}
